/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-07-13 12:52:10
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-15 17:31:40
 * @FilePath: \大屏项目\src\components\element\attrs\cpt-calendar-option.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export default {
    attribute:{
        defaultValueType: null,
        defaultValue: '',
        defaultValueEnd:'',
        defaultValueEN:'',
        defaultValueEndEN:'',
        daterange:false,
        dateFormat:'date',
        label: '日期：',
        labelAlign:'right',
        labelWidth:100,
        placeholder: '请选择',
        size: 'medium', 
        width:144,
        height:32,
        align:"left",
        indent:0,
        bgColor: '#ffffff',
        itembgColor: '#ffffff',
        itemFontColor: '#000000',
        textColor: '#fff',
        textPlaceholderColor: '#333',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        textColor: '#000000',
        borderSize: 1,
        borderColor: '#333333',
        borderRadus: 0,
        lineType: 'solid',
        required: false,
        activeBgColor: '#1f86ed',
        activeColor: '#ffffff',
        disableColor:'#ffffff',

        // selectBgColor: '#1f86ed',
        // selectColor: '#ffffff',
        // selectBrColor:'#ffffff',
        // selectActiveBgColor: '#1f86ed',
        // selectActiveBrColor: '#ffffff',
        // selectActiveColor:'#ffffff',
        
        nowBgColor: '#2684ff',
        nowColor: '#2684ff',
        nowColor:'#ffffff',
        disableBg:'#00000000',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
        btnBg:"#2684ff",
        btnColor:"fff",
        panelColor:"#ffffff8c",
        timeIcon:true,
        timeIconBg:"#333",
        direction:'column',
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
    },
    cptDataForm: {
        dataText: '{"value":""}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    interaction: { eventText: '完成输入时' }
}